import { TableBody, TableCell, TableRow } from "@windmill/react-ui";
import VehicleDrawer from "components/drawer/VehicleDrawer";
import MainDrawer from "components/drawer/MainDrawer";
import DeleteModal from "components/modal/DeleteModal";
import { MdClose } from "react-icons/md";
import ViewModal from "components/modal/ViewVehicle";
import EditDeleteButton from "components/table/EditDeleteButton";
import Tooltip from "components/tooltip/Tooltip";
import { Modal, Box, Typography, IconButton } from "@mui/material";
import useToggleDrawer from "hooks/useToggleDrawer";
import React, { useState, useContext } from "react";
import { SidebarContext } from "context/SidebarContext";
import { FiEye } from "react-icons/fi";
import DriverAproveReject from "components/modal/DriverAproveRejectModel";
import ShowHideButtonBlock from "components/table/ShowHideButtonBlock";
import RemarkModal from "components/modal/RemarkModal";
import { notifyError, notifySuccess } from "utils/toast";
import VehicleServices from "services/VehicleServices";

const VehicleTable = ({
  vehicle,
  perpage,
  currentPage,
  tab,
  hideEdit,
  hideDelete,
}) => {
  const {
    title,
    serviceId,
    serviceBlock,
    handleModalOpen,
    handleView,
    handleUpdate,
    handleBlock,
  } = useToggleDrawer();
  const [isRemarkModalOpen, setIsRemarkModalOpen] = useState(false);
  const [selectedVehicle, setSelectedVehicle] = useState(null);
  const { setIsUpdate } = useContext(SidebarContext);
  const [open, setOpen] = useState(false);
  const [selectedRemark, setSelectedRemark] = useState("");
  const handleClose = () => setOpen(false);

  const [changesOpen, setChangesOpen] = useState(false);
  const [changesArrayData, setChangesArrayData] = useState("");
  const handleChangesClose = () => setChangesOpen(false);

  // const handleStatusChange = (VehicleId, newStatus) => {
  //   let setstatus = 0; // Default status

  //   if (newStatus === 3) {
  //     setstatus = 6; // Rejected Add
  //   } else if (newStatus === 4) {
  //     setstatus = 5; // Rejected Update
  //   } else if (newStatus === 2) {
  //     setstatus = 7; // Rejected Delete
  //   }
  //   if ([6, 5, 7].includes(setstatus)) {
  //     setSelectedVehicle({ id: VehicleId, newStatus: setstatus });
  //     setIsRemarkModalOpen(true);
  //   } else if (setstatus === 3) {
  //     // Direct confirmation for approval
  //     setSelectedVehicle({ id: VehicleId, newStatus: setstatus });
  //     setIsRemarkModalOpen(true);
  //   }
  // };

  const handleStatusChange = (VehicleId) => {
    setSelectedVehicle({ id: VehicleId });
    setIsRemarkModalOpen(true);
  };

  const handleModalAction = async (action, remark) => {
    try {
      const payload = {};

      // if (action === "approve") {
      //   payload.status = 0;
      // } else if (action === "reject") {
      //   payload.status = selectedVehicle.newStatus;
      //   if (selectedVehicle.newStatus === 5) {
      //     payload.cancel_update_remarks = remark;
      //   } else if (selectedVehicle.newStatus === 6) {
      //     payload.cancel_add_remarks = remark;
      //   } else if (selectedVehicle.newStatus === 7) {
      //     payload.cancel_delete_remarks = remark;
      //   }
      // }

      if (action === "approve") {
        payload.remarks = "";
      } else if (action === "reject") {
        payload.remarks = remark;
      }

      const response = await VehicleServices.requestUpdateQueue(
        selectedVehicle.id,
        payload,
      );

      if (response.status) {
        setIsUpdate(true);
        return notifySuccess(response.message);
      } else {
        return notifyError(response.message);
      }
    } catch (error) {
      console.error("Error updating status:", error);
      return notifyError("Error updating status.");
    } finally {
      setIsRemarkModalOpen(false);
      setSelectedVehicle(null);
    }
  };

  const handleOpen = (remark) => {
    setSelectedRemark(remark);
    setOpen(true);
  };

  // const handleChangesOpen = (data) => {
  //   const before = data?.changes?.before || {};
  //   const after = data?.changes?.after || {};

  //   const fieldLabels = {
  //     vehicle_name_id: "Vehicle Name",
  //     vehicle_reg_no: "Vehicle Registration No",
  //     year_of_vehicle_manufactured: "Year of Manufacture",
  //     interior_img_1: "Interior Image 1",
  //     interior_img_2: "Interior Image 2",
  //     exterior_img_1: "Exterior Image 1",
  //     exterior_img_2: "Exterior Image 2",
  //     reg_cer_img: "Registration Certificate",
  //   };

  //   const changedFields = Object.keys(after)
  //     .filter((key) => before[key] !== after[key])
  //     .map((key) => ({
  //       field: fieldLabels[key] || key,
  //       oldValue: before[key] || "-",
  //       newValue: after[key] || "-",
  //     }));

  //   setChangesArrayData(changedFields);
  //   setChangesOpen(true);
  // };

  const handleChangesOpen = (data) => {
    const before = data?.changes?.before || {};
    const after = data?.changes?.after || {};

    const fieldLabels = {
      vehicle_name: "Vehicle Name",
      vehicle_reg_no: "Vehicle Registration No",
      year_of_vehicle_manufactured: "Year of Manufacture",
      interior_img_1: "Interior Image 1",
      interior_img_2: "Interior Image 2",
      exterior_img_1: "Exterior Image 1",
      exterior_img_2: "Exterior Image 2",
      reg_cer_img: "Registration Certificate",
    };

    const excludedFields = ["vehicle_name_id"];

    const changedFields = Object.keys(after)
      .filter((key) => {
        if (excludedFields.includes(key)) return false;
        return before[key] !== after[key];
      })
      .map((key) => ({
        field: fieldLabels[key] || key,
        oldValue: before[key] ?? "-",
        newValue: after[key] ?? "-",
      }));

    setChangesArrayData(changedFields);
    setChangesOpen(true);
  };

  return (
    <>
      <RemarkModal
        id_data={serviceId}
        block_data={serviceBlock}
        title_data={title}
      />
      <DeleteModal id={serviceId} title={title} />
      <ViewModal id={serviceId} title={title} data={vehicle} />
      <MainDrawer>
        <VehicleDrawer id={serviceId} />
      </MainDrawer>
      {isRemarkModalOpen && (
        <DriverAproveReject
          isOpen={isRemarkModalOpen}
          onClose={() => setIsRemarkModalOpen(false)}
          title="Approve or Reject"
          onYesClick={() => handleModalAction("approve", "Approved")}
          onRejectClick={(remark) => handleModalAction("reject", remark)}
        />
      )}
      <TableBody>
        {vehicle?.slice(0, perpage).map((data, index) => (
          <TableRow key={data.id}>
            <TableCell className="text-sm text-center">
              {(currentPage - 1) * perpage + index + 1}
            </TableCell>
            <TableCell className="text-sm text-center">
              {data.vendor_name}
            </TableCell>
            <TableCell className="text-sm text-center">
              {data.vehicle_name}
            </TableCell>
            <TableCell className="text-sm text-center">
              {data.vehicle_reg_no}
            </TableCell>
            {tab !== 1 && tab !== 2 && tab !== 3 && (
              <TableCell className="text-center">
                {/* {data.status === 2 || data.status === 3 || data.status === 4 ? ( */}
                <>
                  <span className="block">Waiting for Approval</span>
                  {hideEdit && (
                    <span
                      className="mt-1 inline-block text-sm text-blue-600 cursor-pointer hover:text-blue-800"
                      onClick={() => handleStatusChange(data.id)}
                    >
                      Action
                    </span>
                  )}
                </>
                {/* ) : null} */}
              </TableCell>
            )}
            {/* {tab !== 1 && tab !== 2 && tab !== 3 && (
              <TableCell className="text-sm" style={{ textAlign: "center" }}>
                <span
                  className="text-md center"

                >
                  {data?.request_type
                    ? data.request_type.charAt(0).toUpperCase() + data.request_type.slice(1)
                    : ""}
                </span>
              </TableCell>
            )}
            {tab !== 1 && tab !== 2 && tab !== 3 && (
              data?.request_type == 'update' ? (<TableCell className="text-sm" style={{ textAlign: "center" }}>
                <span
                  className="text-sm text-blue-500 cursor-pointer center"
                  onClick={() => handleChangesOpen(data)}
                >
                  View
                </span>
              </TableCell>) : (<TableCell className="text-sm" style={{ textAlign: "center" }}>
                <span
                  className="text-sm center"
                >
                  -
                </span>
              </TableCell>
              )
            )} */}

            {tab !== 1 && tab !== 2 && tab !== 3 && (
              <TableCell className="text-sm" style={{ textAlign: "center" }}>
                {/* <span
                  className="text-md center block"
 
                >
                  {data?.request_type == 'add' ? "New" :
                    data.request_type.charAt(0).toUpperCase() + data.request_type.slice(1)
                  }
                </span> */}
                <span
                  className={`text-md center block font-semibold ${
                    data?.request_type === "add"
                      ? "text-green-700"
                      : data?.request_type === "update"
                        ? "text-yellow-500"
                        : "text-gray-800"
                  }`}
                >
                  {data?.request_type === "add"
                    ? "New"
                    : data?.request_type?.charAt(0)?.toUpperCase() +
                      data?.request_type?.slice(1)}
                </span>
                {data?.request_type == "update" ? (
                  <span
                    className="text-sm text-blue-500  block cursor-pointer center"
                    onClick={() => handleChangesOpen(data)}
                  >
                    View
                  </span>
                ) : null}
              </TableCell>
            )}

            {tab !== 0 && tab !== 3 && (
              <TableCell className="text-center space-y-1">
                <div
                  className={
                    data.is_blocked === 1
                      ? "text-red-600 text-sm font-medium"
                      : "text-green-600 text-sm font-medium"
                  }
                >
                  {data.is_blocked === 1 ? "Blocked" : "Active"}
                </div>
                {hideEdit && (
                  <ShowHideButtonBlock
                    id={data.id}
                    block={data.is_blocked}
                    title_block={"Vehicle"}
                    handleBlock={handleBlock}
                  />
                )}
              </TableCell>
            )}
            {tab === 3 && (
              <TableCell className="text-sm" style={{ textAlign: "center" }}>
                {data.cancel_add_remarks ? (
                  <span
                    className="text-sm text-blue-500 cursor-pointer center"
                    onClick={() => handleOpen(data.cancel_add_remarks)}
                  >
                    View
                  </span>
                ) : null}
                {data.cancel_update_remarks ? (
                  <span
                    className="text-sm text-blue-500 cursor-pointer"
                    onClick={() => handleOpen(data.cancel_update_remarks)}
                  >
                    View
                  </span>
                ) : null}
                {data.cancel_delete_remarks ? (
                  <span
                    className="text-sm text-blue-500 cursor-pointer"
                    onClick={() => handleOpen(data.cancel_delete_remarks)}
                  >
                    View
                  </span>
                ) : null}
                {!data.cancel_add_remarks &&
                  !data.cancel_update_remarks &&
                  !data.cancel_delete_remarks && (
                    <span
                      className="text-sm"
                      style={{ display: "block", textAlign: "center" }}
                    >
                      -
                    </span>
                  )}
              </TableCell>
            )}
            {tab === 2 && (
              <TableCell className="text-sm text-center">
                {data.block_remark ? (
                  <span
                    className="text-sm text-blue-500 cursor-pointer"
                    onClick={() => handleOpen(data.block_remark)}
                  >
                    View
                  </span>
                ) : null}
                {!data.block_remark && (
                  <span
                    className="text-sm"
                    style={{ display: "block", textAlign: "center" }}
                  >
                    -
                  </span>
                )}
              </TableCell>
            )}
            <TableCell className="text-center">
              <div className="flex justify-center">
                <div className="p-2 cursor-pointer text-gray-400 hover:text-green-600">
                  <button
                    onClick={() => handleView(data.id, "Vehicle Details")}
                    className="p-2 cursor-pointer text-gray-400 hover:text-red-600 focus:outline-none"
                  >
                    <Tooltip
                      id={data.id}
                      Icon={FiEye}
                      title="ViewOrder"
                      bgColor="#34D399"
                    />
                  </button>
                </div>
                {tab !== 2 && (
                  <EditDeleteButton
                    title={data.name}
                    id={data.id}
                    tab={tab}
                    page="vehicle"
                    handleUpdate={handleUpdate}
                    handleModalOpen={handleModalOpen}
                    hideDelete={hideDelete}
                    hideEdit={hideEdit}
                  />
                )}
              </div>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>

      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            maxWidth: "90%",
            boxShadow: 24,
            maxHeight: "60vh",
            borderRadius: 2,
            padding: "20px",
          }}
          className="bg-white dark:bg-gray-700 dark:text-white"
        >
          <IconButton
            onClick={handleClose}
            sx={{ position: "absolute", top: 8, right: 8 }}
          >
            <MdClose size={24} />
          </IconButton>
          <Typography sx={{ mb: 2 }}>Remark Details</Typography>
          <Typography
            variant="body1"
            sx={{ whiteSpace: "pre-wrap", wordWrap: "break-word" }}
          >
            {selectedRemark}
          </Typography>
        </Box>
      </Modal>

      {/* Changes View Modal  */}
      <Modal open={changesOpen} onClose={handleChangesClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            maxWidth: "90%",
            boxShadow: 24,
            maxHeight: "60vh",
            overflowY: "auto",
            borderRadius: 2,
            padding: "20px",
          }}
          className="bg-white dark:bg-gray-700 dark:text-white"
        >
          <IconButton
            onClick={handleChangesClose}
            sx={{ position: "absolute", top: 8, right: 8 }}
          >
            <MdClose size={24} />
          </IconButton>

          <Typography sx={{ mb: 2, fontWeight: 600 }}>
            Changes Made Details
          </Typography>

          {changesArrayData?.length > 0 ? (
            changesArrayData.map((item, index) => (
              <Box
                key={index}
                sx={{
                  mb: 2,
                  p: 2,
                  border: "1px solid #e5e7eb",
                  borderRadius: 2,
                }}
              >
                <Typography fontWeight={600} sx={{ mb: 1 }}>
                  {item.field}
                </Typography>

                <Typography
                  variant="body2"
                  style={{ textWrap: "wrap" }}
                  sx={{ color: "#dc2626", mb: 0.5 }}
                >
                  <strong>Old:</strong> {item.oldValue || "-"}
                </Typography>

                <Typography
                  variant="body2"
                  style={{ textWrap: "wrap" }}
                  sx={{ color: "#16a34a" }}
                >
                  <strong>New:</strong> {item.newValue || "-"}
                </Typography>
              </Box>
            ))
          ) : (
            <Typography variant="body2">No changes found.</Typography>
          )}
        </Box>
      </Modal>
    </>
  );
};

export default VehicleTable;
